import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import useWorkspaceContext from '../../components/workspaces/WorkspaceContext/WorkspaceContext';

export const useRedirectOnValueChange = (dependentValue, redirectLocation) => {
  const [lastValue, setLastValue] = useState(dependentValue);
  const history = useHistory();
  
  const redirect = useCallback(() => history.push(redirectLocation), [history, redirectLocation]);
  
  useEffect(() => {
    if (lastValue !== dependentValue) {
      setLastValue(dependentValue);
      redirect();
    }
  }, [dependentValue, lastValue, redirect])
}

export const useRedirectOnWorkspaceChange = (redirectLocation) => {
  const { currentWorkspaceId } = useWorkspaceContext()

  useRedirectOnValueChange(currentWorkspaceId, redirectLocation);
};

export default useRedirectOnValueChange;
